import React, { Component } from 'react';
import styled from 'styled-components';
import { ellipsis_color } from '@/styles/theme';
import styles from '@/styles';
const LoadingWrap = styled.div`
  height: ${(props) => (props.height ? props.height : 'calc(100vh - 40px )')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .loading-img .img {
    width: 88px;
    height: 88px;
  }
  .text {
    margin-top: 12px;
    font-size: 12px;
    line-height: 20px;
    color: ${ellipsis_color};
  }
`;
export default class Loading extends Component {
  render() {
    const { text = '买股之前搜一搜', height } = this.props;
    return (
      <LoadingWrap height={height}>
        <div className={'loading-img'}>
          <img src={styles.loading_img} className={'img'} alt=''/>
        </div>
        <div className={'text'}>{text}</div>
      </LoadingWrap>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PageLoading/index.js